// Central mapping of email aliases used across the UI.
// Edition-aware: IndiaAlumni.com uses @indiaalumni.com, AlumniPulse uses @alumnipulse.net.
import { EDITION } from "@/lib/edition";

const e = EDITION.emails || {};

export const EMAILS = {
  noreply: e.noreply,
  contact: e.contact,
  info: e.info,
  privacy: e.privacy || e.legal,
  abuse: e.abuse,
  support: e.support || e.contact,
  legal: e.legal || e.privacy,
  admin: e.admin,
};

export default EMAILS;
